export const CLEAR_MEMBERSHIP_REGISTERS_STATISTICS = 'CLEAR_MEMBERSHIP_REGISTERS_STATISTICS'

export const GET_MEMBERSHIP_REGISTERS_STATISTICS = 'GET_MEMBERSHIP_REGISTERS_STATISTICS'
export const GET_MEMBERSHIP_REGISTERS_STATISTICS_FAILED = 'GET_MEMBERSHIP_REGISTERS_STATISTICS_FAILED'
export const GET_MEMBERSHIP_REGISTERS_STATISTICS_SUCCESS = 'GET_MEMBERSHIP_REGISTERS_STATISTICS_SUCCESS'
